import { render } from "./lateral_tipos_servicio.vue?vue&type=template&id=49d22f70"
import script from "./lateral_tipos_servicio.vue?vue&type=script&lang=js"
export * from "./lateral_tipos_servicio.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__